"use strict";
/* eslint-disable max-len */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disconnected = exports.FailedToSerialize = exports.FailedToParse = exports.UnknownRpcMethod = exports.NotImplemented = exports.RpcClientError = exports.RpcServerError = exports.RpcRequest = exports.RpcTimeout = exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["RPC_TIMEOUT"] = "RPC_TIMEOUT";
    ErrorCode["RPC_REQUEST"] = "RPC_REQUEST";
    ErrorCode["RPC_SERVER_ERROR"] = "RPC_SERVER_ERROR";
    ErrorCode["RPC_CLIENT_ERROR"] = "RPC_CLIENT_ERROR";
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    ErrorCode["UNKNOWN_RPC_METHOD"] = "UNKNOWN_RPC_METHOD";
    ErrorCode["FAILED_TO_PARSE"] = "FAILED_TO_PARSE";
    ErrorCode["FAILED_TO_SERIALIZE"] = "FAILED_TO_SERIALIZE";
    ErrorCode["DISCONNECTED"] = "DISCONNECTED";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
class Err extends Error {
    code;
    originalError;
    constructor(code, message, originalError) {
        super(message);
        this.code = code;
        this.originalError = originalError;
    }
}
class RpcTimeout extends Err {
    constructor(message, originalError) { super(ErrorCode.RPC_TIMEOUT, message, originalError); }
}
exports.RpcTimeout = RpcTimeout;
class RpcRequest extends Err {
    constructor(message, originalError) { super(ErrorCode.RPC_REQUEST, message, originalError); }
}
exports.RpcRequest = RpcRequest;
class RpcServerError extends Err {
    errorClassName;
    errorCode;
    constructor(errorMessage, errorClassName, errorCode) {
        super(ErrorCode.RPC_SERVER_ERROR, errorMessage);
        this.errorClassName = errorClassName;
        this.errorCode = errorCode;
    }
}
exports.RpcServerError = RpcServerError;
class RpcClientError extends Err {
    constructor(message, originalError) { super(ErrorCode.RPC_CLIENT_ERROR, message, originalError); }
}
exports.RpcClientError = RpcClientError;
class NotImplemented extends Err {
    constructor(message, originalError) { super(ErrorCode.NOT_IMPLEMENTED, message, originalError); }
}
exports.NotImplemented = NotImplemented;
class UnknownRpcMethod extends Err {
    constructor(message, originalError) { super(ErrorCode.UNKNOWN_RPC_METHOD, message, originalError); }
}
exports.UnknownRpcMethod = UnknownRpcMethod;
class FailedToParse extends Err {
    constructor(message, originalError) { super(ErrorCode.FAILED_TO_PARSE, message, originalError); }
}
exports.FailedToParse = FailedToParse;
class FailedToSerialize extends Err {
    constructor(message, originalError) { super(ErrorCode.FAILED_TO_SERIALIZE, message, originalError); }
}
exports.FailedToSerialize = FailedToSerialize;
class Disconnected extends Err {
    constructor(message, originalError) { super(ErrorCode.DISCONNECTED, message, originalError); }
}
exports.Disconnected = Disconnected;
//# sourceMappingURL=errors.js.map